<script lang="ts">
	/**
	 * `/Checkout/Canceled` — where the provider sends a customer who backed out (Design §14).
	 *
	 * It is in the `publicRoutes` allowlist and must stay there: the provider redirects to this
	 * URL as a **full page load**, so the app boots from scratch. Bouncing that to the identity
	 * provider would make an abandoned checkout look like a session failure, which is the worst
	 * possible moment to demand a sign-in.
	 *
	 * Nothing is charged here and nothing needs undoing — an abandoned session simply expires.
	 */

	import { onMount } from 'svelte';
	import { EmptyState, PageHeader, RoutedButton } from '../../components';
	import { track } from '../../stores/analytics';

	/*
	 * §12.6's third abandonment, and the only one the customer announces. They reached the
	 * provider's hosted page and came back: recorded here rather than inferred from a session that
	 * later expires, because the expiry is a day away and this is the moment it happened.
	 */
	onMount(() => track('checkout_canceled', { path: '/Checkout/Canceled' }));
</script>

<PageHeader title="Checkout canceled" />

<EmptyState
	faIcon="cart-shopping"
	title="Nothing was charged."
	description="You left the payment page before finishing, so no payment was taken and nothing changed on your account."
>
	<RoutedButton href="/" color="primary" size="sm">Back to the store</RoutedButton>
</EmptyState>
